//兼容各浏览器的加载js组件
function loadJs(src) {
  return new Promise((resolve, reject) => {
    let scripts = document.getElementsByTagName('script')
    let script
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].src == src) {
        script = scripts[i]
        break
      }
    }

    if (!script) {
      script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = src
      script.onload = script.onreadystatechange = () => {
        if (
          !script.readyState ||
          script.readyState == 'loaded' ||
          script.readyState == 'complete'
        ) {
          script.onreadystatechange = null
          resolve()
        }
      }

      // script.onload = ()=>{
      //   resolve();
      // }

      script.onerror = () => {
        reject()
      }

      document.body.appendChild(script)
    } else {
      resolve()
    }
  })
}

export default loadJs
